module.exports = __webpack_public_path__ + "static/media/insurance-web.623eac48.png";